module.exports = __webpack_public_path__ + "static/Shield-left-a32058397fda024b856fc67cd4cd99a7.png";